import axios from 'axios';

const apiBasePath = process.env.REACT_APP_API_BASE_URL;

export const fetchToken = (username: string, password: string) => {
	return axios.post(`${apiBasePath}/auth`, { username, password });
};
